import { setProps } from '../props';

export default (props: any) => async () => {

  setProps(props);
  
}
